import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage.tsx';
import type { ActionButtonProps } from '@openx/components-header/HeaderActions/ActionButton.tsx';
import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions.tsx';
import { PageHeader } from '@openx/components-header/PageHeader.tsx';
import { OrganizationsList } from '@openx/components-organization/lib/components/OrganizationsList/OrganizationsList.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../components/AuthContext/context.ts';
import { isAdmin } from '../../permissions/validators.ts';
import { useGetOrganizationsDataAndCriteria } from './OrganizationsList/hooks/useGetOrganizationsDataAndCriteria.tsx';

export const OrganizationsListPage = () => {
  const { session } = useAuth();
  const { t } = useTranslation();
  const isAllowed = useMemo(() => isAdmin(session), [session]);
  const { criteria, error, handleCriteriaChange, loading, organizations } = useGetOrganizationsDataAndCriteria();

  const actions: Array<ActionButtonProps> = [
    {
      color: 'primary',
      'data-test': 'create-organization-button',
      href: '/organizations/create',
      label: t('Create New Organization'),
      showAsActionButton: true,
    },
  ];

  if (!isAllowed) return <AccessForbiddenPage />;

  if (error) throw new Error('Organizations Error');

  return (
    <PageHeader
      render={() => <HeaderActions actions={actions} />}
      titlePrefix="OpenXSelect"
      title={t('Organizations List')}
      sticky
    >
      <OrganizationsList
        criteria={criteria}
        handleCriteriaChange={handleCriteriaChange}
        loading={loading}
        organizations={organizations}
      />
    </PageHeader>
  );
};
